"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrandingCameraOffLDFlagEnabled = exports.isBrandingCameraOffFeatureEnabled = exports.dispatchBrandingSettings = void 0;
var _featureFlags = require("@studio/feature.flags/featureFlags");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _Branding = require("@studio/constants/Branding");
var logger = new _StudioLogger.StudioLogger('branding');

/**
 * checks whether camera off feature is enabled or not for Cventized events
 * @param {boolean} brandingSetting - Branding setting flag in a broadcast.
 * @returns {*|boolean}
 */
var isBrandingCameraOffFeatureEnabled = exports.isBrandingCameraOffFeatureEnabled = function isBrandingCameraOffFeatureEnabled(brandingSetting) {
  return isBrandingCameraOffLDFlagEnabled() && brandingSetting;
};

/**
 * checks whether branding camera off feature is enabled or not
 * @returns {*|boolean}
 */
var isBrandingCameraOffLDFlagEnabled = exports.isBrandingCameraOffLDFlagEnabled = function isBrandingCameraOffLDFlagEnabled() {
  return (0, _featureFlags.shouldHaveFeature)('branding.cameraOffState');
};

/**
 * dispatches branding settings
 * @param {boolean} brandingSetting - Branding setting flag in a broadcast.
 * @param {function} dispatch - The Redux dispatch function used to send actions.
 * @param {function} getBrandingSettings - A function that returns an action to get branding settings.
 */
var dispatchBrandingSettings = exports.dispatchBrandingSettings = function dispatchBrandingSettings(brandingSetting, dispatch, getBrandingSettings) {
  if (brandingSetting) {
    dispatch(getBrandingSettings());
    var logPayload = {
      reduxActionFired: 'getBrandingSettings',
      title: "Fetching branding settings"
    };
    logger.info(logPayload.title, logPayload);
  } else {
    dispatch({
      type: "".concat(_Branding.GET_BRANDING_SETTINGS, "_SUCCESS"),
      payload: _Branding.DEFAULT_BRANDING
    });
  }
};